var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHistorico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3CDBC0",
    d: "M487,304.505v-97.01C464.631,100.426,369.711,20,256,20v472C369.711,492,464.631,411.574,487,304.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F41",
    d: "M390.953,363.169c-0.021-0.021-0.043-0.037-0.063-0.058l0.003-0.003L276,248.216V116h-0.025 c-0.268-10.812-9.098-19.5-19.975-19.5s-19.707,8.688-19.975,19.5H236v140h0.025c-0.004,0.168-0.025,0.331-0.025,0.5 c0,5.799,2.483,11.006,6.426,14.659l-0.026,0.025l120.208,120.208l0.003-0.003c0.021,0.021,0.037,0.043,0.058,0.063 c7.811,7.811,20.474,7.811,28.284,0S398.764,370.979,390.953,363.169z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F41",
    d: "M256,0C185.203,0,121.12,28.741,74.777,75.189l-0.509,0.079L38,39.5V140h101l-36.008-36.258l0.062-0.137 C142.16,64.392,196.245,40.062,256,40.062c119.293,0,216,96.676,216,215.969s-96.707,215.984-216,215.984S40,375.301,40,256.008 c0-29.076,5.759-56.809,16.177-82.128l-36.959-15.322C6.842,188.597,0,221.497,0,256.001C0,397.386,114.615,512,256,512 s256-114.615,256-256S397.385,0,256,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistorico);
export default __webpack_public_path__ + "static/media/icon_historico.66ccfe4b31f6a923093cdb414025d17f.svg";
export { ForwardRef as ReactComponent };